import React from 'react'

export function isCategoryLandingLayoutColorKey(key) {
  return typeof key === 'string' && /Color$/i.test(key)
}

function normalizeHexForPicker(input) {
  const s = String(input || '').trim()
  if (!/^#[0-9A-Fa-f]{3}$|^#[0-9A-Fa-f]{6}$/.test(s)) return null
  const body = s.slice(1)
  if (body.length === 3) {
    const [a, b, c] = body.split('')
    return `#${a}${a}${b}${b}${c}${c}`.toLowerCase()
  }
  return `#${body.toLowerCase()}`
}

/**
 * 레이아웃 customConfig 색상: HTML color 피커 + 16진 문자열 입력 (한 필드당 한 줄)
 */
export default function CategoryLandingLayoutColorField({ value, onChange, placeholder, wrapperClassName = 'mt-1' }) {
  const raw = value == null ? '' : String(value)
  const fromValue = normalizeHexForPicker(raw)
  const fromPlaceholder = normalizeHexForPicker(placeholder || '')
  const pickerValue = fromValue || fromPlaceholder || '#888888'

  return (
    <div className={`flex items-center gap-2 ${wrapperClassName}`}>
      <input
        type="color"
        aria-label="색상 피커"
        className="h-10 w-12 shrink-0 cursor-pointer rounded border border-slate-300 bg-white p-0.5"
        value={pickerValue}
        onChange={(e) => onChange(e.target.value)}
      />
      <input
        type="text"
        className="min-w-0 flex-1 rounded border px-3 py-2 font-mono text-sm"
        value={raw}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder || '#000000'}
        spellCheck={false}
      />
    </div>
  )
}
